module.exports = __webpack_public_path__ + "img/invoice-time.3c53f029.svg";